import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3188faa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main-tabs"
}
const _hoisted_2 = {
  key: 1,
  class: "main-tabs dragon-main-tabs"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dragon-popover-content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-title" }, "龙头冲刺"),
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-desc" }, "该信号指具备板块效应，呈现强势态势的龙头股。"),
  /*#__PURE__*/_createElementVNode("p", {
    class: "dragon-popover-title",
    style: {"margin-top":"12px"}
  }, "龙头点火"),
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-desc" }, "该信号指具备板块热度扩散，有晋级潜力的龙头股。")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dragon-info-icon commonquestion" }, null, -1))
const _hoisted_5 = {
  key: 2,
  class: "main-tabs"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dragon-popover-content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-title" }, "龙头启动"),
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-desc" }, "是指具备板块效应，自上而下寻找龙头股。"),
  /*#__PURE__*/_createElementVNode("p", {
    class: "dragon-popover-title",
    style: {"margin-top":"12px"}
  }, "龙头加强"),
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-desc" }, "在龙头启动的基础上，筛选走势更强势的龙头股。"),
  /*#__PURE__*/_createElementVNode("p", {
    class: "dragon-popover-title",
    style: {"margin-top":"12px"}
  }, "后排超车"),
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-desc" }, "后排超车是指板块热度扩散，有后排晋级潜力的个股。"),
  /*#__PURE__*/_createElementVNode("p", {
    class: "dragon-popover-title",
    style: {"margin-top":"12px"}
  }, "二波左侧"),
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-desc" }, "指前期强势，回档至重要均线支撑，止跌信号、资金与技术共振的个股。"),
  /*#__PURE__*/_createElementVNode("p", {
    class: "dragon-popover-title",
    style: {"margin-top":"12px"}
  }, "二波右侧"),
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-desc" }, "指前期强势，回档至重要均线支撑，再次强势启动的个股。")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dragon-info-icon commonquestion" }, null, -1))
const _hoisted_8 = {
  key: 3,
  class: "main-tabs"
}
const _hoisted_9 = { class: "filter-header" }
const _hoisted_10 = { class: "left-section" }
const _hoisted_11 = {
  key: 0,
  class: "signal-tabs"
}
const _hoisted_12 = {
  key: 1,
  class: "signal-tabs quant-gold-signal-tabs"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dragon-popover-content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-title" }, "进场信号"),
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-desc" }, "通过机器学习模型持续推演300余项资金特征因子，筛选出区间上涨潜力高的个股"),
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-title quant-gold-popover-gap" }, "离场信号"),
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-desc" }, "通过机器学习模型对进场信号的持续跟踪，优选出最佳平仓时机"),
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-title quant-gold-popover-gap" }, "上涨空间"),
  /*#__PURE__*/_createElementVNode("p", { class: "dragon-popover-desc" }, "用来评估当前买点的预期最大上涨潜力，星级越高，上涨上限越高")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "quant-gold-signal-info-icon commonquestion" }, null, -1))
const _hoisted_15 = {
  key: 2,
  ref: "quantGoldScanningRef",
  class: "ai-scanning-lottie"
}
const _hoisted_16 = {
  key: 3,
  class: "update-time"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "更新时间：", -1))
const _hoisted_18 = { class: "time-text" }
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 4,
  class: "history-date-select quant-gold-history"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "选择日期：", -1))
const _hoisted_22 = {
  key: 5,
  class: "signal-tabs"
}
const _hoisted_23 = {
  key: 6,
  class: "update-time"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "更新时间：", -1))
const _hoisted_25 = { class: "time-text" }
const _hoisted_26 = ["src"]
const _hoisted_27 = {
  key: 7,
  class: "dragon-hunter-before-actions"
}
const _hoisted_28 = {
  key: 8,
  class: "update-time"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "更新时间：", -1))
const _hoisted_30 = { class: "time-text" }
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 0,
  class: "stock-count-inline"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stock-count-label" }, "股票数量：", -1))
const _hoisted_34 = { class: "stock-count-value" }
const _hoisted_35 = {
  key: 9,
  class: "update-time"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "更新时间：", -1))
const _hoisted_37 = { class: "time-text" }
const _hoisted_38 = ["src"]
const _hoisted_39 = {
  key: 0,
  class: "stock-count-inline"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stock-count-label" }, "股票数量：", -1))
const _hoisted_41 = { class: "stock-count-value" }
const _hoisted_42 = {
  key: 10,
  class: "history-date-select"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "选择日期：", -1))
const _hoisted_44 = {
  key: 0,
  class: "stock-count-inline"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "stock-count-label" }, "股票数量：", -1))
const _hoisted_46 = { class: "stock-count-value" }
const _hoisted_47 = { class: "actions" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" 只看自选 ")
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" 只看自选 ")
const _hoisted_50 = {
  class: "stock-search-wrapper",
  style: {"margin-left":"12px"}
}
const _hoisted_51 = {
  key: 0,
  class: "dragon-hunter-selected-stock"
}
const _hoisted_52 = { class: "selected-stock-text" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "option-code" }
const _hoisted_55 = {
  class: "option-name",
  style: {"margin-left":"8px"}
}
const _hoisted_56 = ["onClick"]
const _hoisted_57 = {
  key: 2,
  class: "stock-search-wrapper"
}
const _hoisted_58 = /*#__PURE__*/_createTextVNode("> ")
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { class: "stock-code" }
const _hoisted_61 = ["title"]
const _hoisted_62 = { class: "stock-market" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" 只看自选 ")
const _hoisted_65 = { class: "filter-content-popup" }
const _hoisted_66 = { class: "filter-scroll-area" }
const _hoisted_67 = { class: "filter-group" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-label" }, "上涨空间", -1))
const _hoisted_69 = { class: "filter-options" }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = { class: "filter-actions" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "↻", -1))
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" 恢复默认 ")
const _hoisted_74 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_75 = ["src"]
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" 筛选 ")
const _hoisted_77 = { class: "filter-content-popup" }
const _hoisted_78 = { class: "filter-scroll-area" }
const _hoisted_79 = { class: "filter-group" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-label" }, "趋势势能", -1))
const _hoisted_81 = { class: "filter-options" }
const _hoisted_82 = { class: "filter-group" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-label" }, "资金标尺", -1))
const _hoisted_84 = { class: "filter-options" }
const _hoisted_85 = { class: "filter-group" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "filter-label" }, "题材追踪", -1))
const _hoisted_87 = { class: "filter-options" }
const _hoisted_88 = { class: "filter-actions" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, "↻", -1))
const _hoisted_90 = /*#__PURE__*/_createTextVNode(" 恢复默认 ")
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" 确定 ")
const _hoisted_92 = ["src"]
const _hoisted_93 = /*#__PURE__*/_createTextVNode(" 筛选 ")
const _hoisted_94 = { class: "hot-case-intro-row" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hot-case-intro-text" }, " 我们统计了近期不同时间周期内，入选股池后累计涨幅表现最佳的标的股。 ", -1))
const _hoisted_96 = ["value"]
const _hoisted_97 = ["value"]
const _hoisted_98 = {
  key: 4,
  class: "selected-stock-info"
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "入选股票：", -1))
const _hoisted_100 = { class: "info-count" }
const _hoisted_101 = { class: "info-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["filter-panel", _ctx.theme]),
    ref: "filterPanelRef"
  }, [
    (_ctx.isMengzhuTrend && _ctx.mainTabs)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", {
            class: _normalizeClass(['main-tab', { active: _ctx.currentMainTab === 'signalPool' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleMainTabChange('signalPool')))
          }, _toDisplayString(_ctx.mainTabs.signalPool?.label || '信号池'), 3),
          _createElementVNode("span", {
            class: _normalizeClass(['main-tab', { active: _ctx.currentMainTab === 'hotCases' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleMainTabChange('hotCases')))
          }, _toDisplayString(_ctx.mainTabs.hotCases?.label || '近30天热门案例'), 3)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isDragonSignal && _ctx.mainTabs)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", {
            class: _normalizeClass(['main-tab', { active: _ctx.currentMainTab === 'dragon_signal_sprint' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleMainTabChange('dragon_signal_sprint')))
          }, _toDisplayString(_ctx.mainTabs.signalPool?.label || '龙头冲刺'), 3),
          _createElementVNode("span", {
            class: _normalizeClass(['main-tab', { active: _ctx.currentMainTab === 'dragon_signal_ignition' }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleMainTabChange('dragon_signal_ignition')))
          }, _toDisplayString(_ctx.mainTabs.hotCases?.label || '龙头点火'), 3),
          _createVNode(_component_a_popover, {
            placement: "bottomLeft",
            overlayClassName: "dragon-info-popover",
            getPopupContainer: _ctx.getPopupContainer
          }, {
            content: _withCtx(() => [
              _hoisted_3
            ]),
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["getPopupContainer"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isDragonHunter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", {
            class: _normalizeClass(['main-tab', { active: _ctx.dragonHunterMainTab === 'newChose' }]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleMainTabChange('newChose')))
          }, "最新入选", 2),
          _createElementVNode("span", {
            class: _normalizeClass(['main-tab', { active: _ctx.dragonHunterMainTab === 'dataTrack' }]),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleMainTabChange('dataTrack')))
          }, "数据追踪", 2),
          _createElementVNode("span", {
            class: _normalizeClass(['main-tab', { active: _ctx.dragonHunterMainTab === 'hotCase' }]),
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleMainTabChange('hotCase')))
          }, "热门案例", 2),
          _createElementVNode("span", {
            class: _normalizeClass(['main-tab', { active: _ctx.dragonHunterMainTab === 'beforeChose' }]),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleMainTabChange('beforeChose')))
          }, "查看往期", 2),
          _createVNode(_component_a_popover, {
            placement: "bottomLeft",
            overlayClassName: "dragon-info-popover",
            getPopupContainer: _ctx.getPopupContainer
          }, {
            content: _withCtx(() => [
              _hoisted_6
            ]),
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["getPopupContainer"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isQuantGold)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("span", {
            class: _normalizeClass(['main-tab', { active: _ctx.quantGoldMainTab === 'newChose' }]),
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleMainTabChange('newChose')))
          }, "最新入选", 2),
          _createElementVNode("span", {
            class: _normalizeClass(['main-tab', { active: _ctx.quantGoldMainTab === 'dataTrack' }]),
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleMainTabChange('dataTrack')))
          }, "数据追踪", 2),
          _createElementVNode("span", {
            class: _normalizeClass(['main-tab', { active: _ctx.quantGoldMainTab === 'hotCase' }]),
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleMainTabChange('hotCase')))
          }, "热门案例", 2),
          _createElementVNode("span", {
            class: _normalizeClass(['main-tab', { active: _ctx.quantGoldMainTab === 'beforeChose' }]),
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleMainTabChange('beforeChose')))
          }, "查看往期", 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        (!_ctx.isDragonHunter && !_ctx.isQuantGold && (!_ctx.isMengzhuTrend || _ctx.currentMainTab === 'signalPool'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("span", {
                class: _normalizeClass(['tab', { active: _ctx.signalType === 'latest' }]),
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleSignalTypeChange('latest')))
              }, _toDisplayString(_ctx.signalTabLabels.latest), 3),
              _createElementVNode("span", {
                class: _normalizeClass(['tab', { active: _ctx.signalType === 'history' }]),
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleSignalTypeChange('history')))
              }, _toDisplayString(_ctx.signalTabLabels.history), 3),
              (_ctx.isDragonSignal)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(['tab', { active: _ctx.signalType === 'backtest' }]),
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleSignalTypeChange('backtest')))
                  }, " 回测数据跟踪 ", 2))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isQuantGold && (_ctx.quantGoldMainTab === 'newChose' || _ctx.quantGoldMainTab === 'beforeChose'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("span", {
                class: _normalizeClass(['tab', { active: _ctx.quantGoldSubTab === 'entrySignal' }]),
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleQuantGoldSubTabChange('entrySignal')))
              }, "进场信号", 2),
              _createElementVNode("span", {
                class: _normalizeClass(['tab', { active: _ctx.quantGoldSubTab === 'exitSignal' }]),
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleQuantGoldSubTabChange('exitSignal')))
              }, "离场信号", 2),
              _createVNode(_component_a_popover, {
                placement: "bottomLeft",
                overlayClassName: "dragon-info-popover",
                getPopupContainer: _ctx.getPopupContainer
              }, {
                content: _withCtx(() => [
                  _hoisted_13
                ]),
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["getPopupContainer"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isQuantGold && _ctx.quantGoldMainTab === 'newChose')
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, null, 512))
          : _createCommentVNode("", true),
        (_ctx.isQuantGold && _ctx.quantGoldMainTab === 'newChose')
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.updateTime || '--'), 1),
              _createElementVNode("span", {
                class: "refresh-icon",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.handleRefresh && _ctx.handleRefresh(...args)))
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/Refresh.png'),
                  alt: "刷新"
                }, null, 8, _hoisted_19)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isQuantGold && _ctx.quantGoldMainTab === 'beforeChose')
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _hoisted_21,
              _createVNode(_component_a_date_picker, {
                value: _ctx.quantGoldSelectedDateMoment,
                "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.quantGoldSelectedDateMoment) = $event)),
                style: {"width":"160px"},
                format: "YYYY-MM-DD",
                placeholder: "请选择日期",
                allowClear: false,
                disabledDate: _ctx.quantGoldDisabledDate,
                getCalendarContainer: _ctx.getPopupContainer,
                dropdownClassName: _ctx.datePickerDropdownClass,
                renderFooter: () => null,
                onOpenChange: _cache[19] || (_cache[19] = (open) => _ctx.handleDatePickerOpenChange(open, '.quant-gold-history .ant-calendar-picker'))
              }, null, 8, ["value", "disabledDate", "getCalendarContainer", "dropdownClassName", "renderFooter"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isDragonHunter && (_ctx.dragonHunterMainTab === 'newChose' || _ctx.dragonHunterMainTab === 'dataTrack'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("span", {
                class: _normalizeClass(['tab', { active: _ctx.dragonHunterSubTab === 'dragonStar' }]),
                onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleDragonHunterSubTabChange('dragonStar')))
              }, "龙头启动", 2),
              _createElementVNode("span", {
                class: _normalizeClass(['tab', { active: _ctx.dragonHunterSubTab === 'dragonDouble' }]),
                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.handleDragonHunterSubTabChange('dragonDouble')))
              }, "龙头加强", 2),
              _createElementVNode("span", {
                class: _normalizeClass(['tab', { active: _ctx.dragonHunterSubTab === 'overTaking' }]),
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.handleDragonHunterSubTabChange('overTaking')))
              }, "后排超车", 2),
              _createElementVNode("span", {
                class: _normalizeClass(['tab', { active: _ctx.dragonHunterSubTab === 'dragonLeft' }]),
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.handleDragonHunterSubTabChange('dragonLeft')))
              }, "二波左侧", 2),
              _createElementVNode("span", {
                class: _normalizeClass(['tab', { active: _ctx.dragonHunterSubTab === 'dragonRight' }]),
                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.handleDragonHunterSubTabChange('dragonRight')))
              }, "二波右侧", 2)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isDragonHunter && _ctx.dragonHunterMainTab === 'newChose')
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.updateTime || '--'), 1),
              _createElementVNode("span", {
                class: "refresh-icon",
                onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.handleRefresh && _ctx.handleRefresh(...args)))
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/Refresh.png'),
                  alt: "刷新"
                }, null, 8, _hoisted_26)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isDragonHunter && _ctx.dragonHunterMainTab === 'beforeChose')
          ? (_openBlock(), _createElementBlock("div", _hoisted_27))
          : _createCommentVNode("", true),
        (!_ctx.isDragonHunter && !_ctx.isQuantGold && _ctx.signalType === 'latest' && (!_ctx.isMengzhuTrend || _ctx.currentMainTab === 'signalPool'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.updateTime || '--'), 1),
              _createElementVNode("span", {
                class: "refresh-icon",
                onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.handleRefresh && _ctx.handleRefresh(...args)))
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/Refresh.png'),
                  alt: "刷新"
                }, null, 8, _hoisted_31)
              ]),
              (_ctx.showStockCount)
                ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.stockCount), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (!_ctx.isDragonHunter && !_ctx.isQuantGold && !_ctx.showHistoryDateSelect && (!_ctx.isMengzhuTrend || _ctx.currentMainTab === 'signalPool'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.updateTime || '--'), 1),
                _createElementVNode("span", {
                  class: "refresh-icon",
                  onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.handleRefresh && _ctx.handleRefresh(...args)))
                }, [
                  _createElementVNode("img", {
                    src: require('@/assets/Refresh.png'),
                    alt: "刷新"
                  }, null, 8, _hoisted_38)
                ]),
                (_ctx.showStockCount)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                      _hoisted_40,
                      _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.stockCount), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (!_ctx.isDragonHunter && !_ctx.isQuantGold && (!_ctx.isMengzhuTrend || _ctx.currentMainTab === 'signalPool') && _ctx.signalType !== 'backtest')
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _hoisted_43,
                  _createVNode(_component_a_date_picker, {
                    value: _ctx.selectedDateMoment,
                    "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.selectedDateMoment) = $event)),
                    style: {"width":"160px"},
                    format: "YYYY-MM-DD",
                    placeholder: "请选择日期",
                    allowClear: false,
                    disabledDate: _ctx.disabledDate,
                    getCalendarContainer: _ctx.getPopupContainer,
                    dropdownClassName: _ctx.datePickerDropdownClass,
                    onChange: _ctx.onHistoryDateSelect,
                    renderFooter: () => null,
                    onOpenChange: _cache[29] || (_cache[29] = (open) => _ctx.handleDatePickerOpenChange(open, '.history-date-select:not(.quant-gold-history) .ant-calendar-picker'))
                  }, null, 8, ["value", "disabledDate", "getCalendarContainer", "dropdownClassName", "onChange", "renderFooter"]),
                  (_ctx.showStockCount)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_44, [
                        _hoisted_45,
                        _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.stockCount), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_47, [
        ((!_ctx.isMengzhuTrend || _ctx.currentMainTab === 'signalPool') && _ctx.signalType !== 'backtest' && !_ctx.isDragonHunter && !_ctx.isQuantGold)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(['only-optional', { active: _ctx.onlyOptional }]),
              onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.toggleOptional && _ctx.toggleOptional(...args)))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(['checkbox-icon', { active: _ctx.onlyOptional }])
              }, null, 2),
              _hoisted_48
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.isDragonHunter && _ctx.dragonHunterMainTab === 'beforeChose')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("span", {
                class: _normalizeClass(['only-optional', { active: _ctx.dragonHunterOnlyOptional }]),
                onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.toggleDragonHunterOptional && _ctx.toggleDragonHunterOptional(...args)))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(['checkbox-icon', { active: _ctx.dragonHunterOnlyOptional }])
                }, null, 2),
                _hoisted_49
              ], 2),
              _createElementVNode("div", _hoisted_50, [
                (_ctx.dragonHunterDisplayValue)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.dragonHunterDisplayValue), 1),
                      _createElementVNode("span", {
                        class: "selected-stock-clear",
                        onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.handleDragonHunterClear && _ctx.handleDragonHunterClear(...args)))
                      }, "×")
                    ]))
                  : (_openBlock(), _createBlock(_component_a_select, {
                      key: 1,
                      ref: "dragonHunterSearchRef",
                      value: _ctx.dragonHunterSearchValue,
                      "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.dragonHunterSearchValue) = $event)),
                      "show-search": "",
                      placeholder: "搜索个股",
                      style: {"width":"160px"},
                      "show-arrow": false,
                      "filter-option": false,
                      getPopupContainer: _ctx.getPopupContainer,
                      "not-found-content": null,
                      open: _ctx.dragonHunterDropdownOpen,
                      onSearch: _ctx.handleDragonHunterSearch,
                      onFocus: _ctx.handleDragonHunterFocus,
                      onBlur: _ctx.handleDragonHunterBlur,
                      onSelect: _ctx.handleDragonHunterSelect,
                      dropdownClassName: (_ctx.theme === 'dark' ? 'dark-dropdown' : 'light-dropdown') + ' dragon-hunter-dropdown'
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dragonHunterDisplayOptions, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            value: item.Id || item.Code,
                            key: item.Id || item.Code
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: "dragon-hunter-option-item",
                                onClick: _withModifiers(($event: any) => (_ctx.handleDragonHunterStockClick(item)), ["stop"])
                              }, [
                                _createElementVNode("span", _hoisted_54, _toDisplayString(item.Code), 1),
                                _createElementVNode("span", _hoisted_55, _toDisplayString(item.Name), 1),
                                (_ctx.dragonHunterIsShowingHistory)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: "option-delete",
                                      onClick: _withModifiers(($event: any) => (_ctx.removeFromDragonHunterHistory(item, $event)), ["stop"])
                                    }, "×", 8, _hoisted_56))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_53)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "getPopupContainer", "open", "onSearch", "onFocus", "onBlur", "onSelect", "dropdownClassName"]))
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.showStockSearch)
          ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
              _createVNode(_component_a_select, {
                ref: "stockSearchRef",
                value: _ctx.searchStock,
                "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.searchStock) = $event)),
                "show-search": "",
                placeholder: '搜索个股筹码大师',
                style: {"width":"200px"},
                "show-arrow": false,
                "filter-option": false,
                getPopupContainer: _ctx.getPopupContainer,
                "not-found-content": null,
                open: _ctx.searchDropdownOpen,
                onSearch: _ctx.handleStockSearch,
                onFocus: _ctx.handleSearchFocus,
                onBlur: _ctx.handleSearchBlur,
                onDropdownVisibleChange: _ctx.handleDropdownVisibleChange,
                onSelect: _ctx.handleOptionSelect,
                listHeight: 300,
                virtual: false,
                dropdownClassName: _ctx.theme === 'dark' ? 'dark-dropdown' : 'light-dropdown'
              }, {
                default: _withCtx(() => [
                  _hoisted_58,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.Id,
                      key: item.Id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "stock-option-item",
                          onClick: _withModifiers(($event: any) => (_ctx.handleStockSelect(item)), ["stop"])
                        }, [
                          _createElementVNode("span", _hoisted_60, _toDisplayString(item.Code), 1),
                          _createElementVNode("span", {
                            class: "stock-name",
                            title: item.Name
                          }, _toDisplayString(_ctx.formatStockName(item.Name)), 9, _hoisted_61),
                          _createElementVNode("span", _hoisted_62, _toDisplayString(item.MarketCode === 'sh' ? '沪A' : item.MarketCode === 'sz' ? '深A' :
                  item.MarketCode === 'bj' ? '京A' : ''), 1),
                          (_ctx.isShowingHistory)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "history-delete-icon",
                                onClick: _withModifiers(($event: any) => (_ctx.removeFromHistory(item, $event)), ["stop"])
                              }, "×", 8, _hoisted_63))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_59)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "getPopupContainer", "open", "onSearch", "onFocus", "onBlur", "onDropdownVisibleChange", "onSelect", "dropdownClassName"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isQuantGold && _ctx.quantGoldShowListActions)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("span", {
                class: _normalizeClass(['only-optional', { active: _ctx.onlyOptional }]),
                onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.toggleOptional && _ctx.toggleOptional(...args)))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(['checkbox-icon', { active: _ctx.onlyOptional }])
                }, null, 2),
                _hoisted_64
              ], 2),
              (_ctx.showFilterBtn && _ctx.quantGoldSubTab === 'entrySignal')
                ? (_openBlock(), _createBlock(_component_a_popover, {
                    key: 0,
                    visible: _ctx.showQuantGoldFilter,
                    placement: "bottomRight",
                    overlayClassName: _ctx.filterPopoverClass,
                    getPopupContainer: _ctx.getPopupContainer
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            _hoisted_68,
                            _createElementVNode("div", _hoisted_69, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([5, 4, 3], (star) => {
                                return _createElementVNode("span", {
                                  key: star,
                                  class: _normalizeClass(['option', { active: _ctx.quantGoldFilters.upSpaceStars.includes(star) }]),
                                  onClick: ($event: any) => (_ctx.toggleQuantGoldStar(star))
                                }, _toDisplayString(star) + "星", 11, _hoisted_70)
                              }), 64))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_71, [
                          _createVNode(_component_a_button, {
                            class: "reset-btn",
                            onClick: _ctx.handleQuantGoldFilterReset
                          }, {
                            default: _withCtx(() => [
                              _hoisted_72,
                              _hoisted_73
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_a_button, {
                            type: "primary",
                            class: "confirm-btn",
                            onClick: _ctx.handleQuantGoldFilterConfirm
                          }, {
                            default: _withCtx(() => [
                              _hoisted_74
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        ref: "quantGoldFilterBtnRef",
                        class: _normalizeClass(['filter-btn', { active: _ctx.isQuantGoldFilterActive }]),
                        onClick: _cache[36] || (_cache[36] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleQuantGoldFilter && _ctx.toggleQuantGoldFilter(...args)), ["stop"]))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.getFilterIcon(),
                          alt: "筛选",
                          class: "filter-icon"
                        }, null, 8, _hoisted_75),
                        _hoisted_76
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["visible", "overlayClassName", "getPopupContainer"]))
                : _createCommentVNode("", true)
            ], 64))
          : (_ctx.showFilterBtn && !_ctx.isQuantGold)
            ? (_openBlock(), _createBlock(_component_a_popover, {
                key: 4,
                visible: _ctx.showFilter,
                placement: "bottomRight",
                overlayClassName: _ctx.filterPopoverClass,
                getPopupContainer: _ctx.getPopupContainer
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("div", _hoisted_79, [
                        _hoisted_80,
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("span", {
                            class: _normalizeClass(['option', { active: _ctx.filters.macd === 0 }]),
                            onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.setFilter('macd', 0)))
                          }, "全部", 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(['option', { active: _ctx.filters.macd === 1 }]),
                            onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.setFilter('macd', 1)))
                          }, "强势", 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(['option', { active: _ctx.filters.macd === 2 }]),
                            onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.setFilter('macd', 2)))
                          }, "弱势", 2)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_82, [
                        _hoisted_83,
                        _createElementVNode("div", _hoisted_84, [
                          _createElementVNode("span", {
                            class: _normalizeClass(['option', { active: _ctx.filters.amount === 0 }]),
                            onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.setFilter('amount', 0)))
                          }, "全部", 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(['option', { active: _ctx.filters.amount === 1 }]),
                            onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.setFilter('amount', 1)))
                          }, "强势", 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(['option', { active: _ctx.filters.amount === 2 }]),
                            onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.setFilter('amount', 2)))
                          }, "弱势", 2)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_85, [
                        _hoisted_86,
                        _createElementVNode("div", _hoisted_87, [
                          _createElementVNode("span", {
                            class: _normalizeClass(['option', { active: _ctx.filters.plate === 0 }]),
                            onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.setFilter('plate', 0)))
                          }, "全部", 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(['option', { active: _ctx.filters.plate === 1 }]),
                            onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.setFilter('plate', 1)))
                          }, "核心风口", 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(['option', { active: _ctx.filters.plate === 2 }]),
                            onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.setFilter('plate', 2)))
                          }, "普通风口", 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(['option', { active: _ctx.filters.plate === 3 }]),
                            onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.setFilter('plate', 3)))
                          }, "未入选", 2)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_88, [
                      _createVNode(_component_a_button, {
                        class: "reset-btn",
                        onClick: _ctx.handleReset
                      }, {
                        default: _withCtx(() => [
                          _hoisted_89,
                          _hoisted_90
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_a_button, {
                        type: "primary",
                        class: "confirm-btn",
                        onClick: _ctx.handleConfirm
                      }, {
                        default: _withCtx(() => [
                          _hoisted_91
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    ref: "commonFilterBtnRef",
                    class: _normalizeClass(['filter-btn', { active: _ctx.isFilterActive }]),
                    onClick: _cache[47] || (_cache[47] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args)), ["stop"]))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.getFilterIcon(),
                      alt: "筛选",
                      class: "filter-icon"
                    }, null, 8, _hoisted_92),
                    _hoisted_93
                  ], 2)
                ]),
                _: 1
              }, 8, ["visible", "overlayClassName", "getPopupContainer"]))
            : _createCommentVNode("", true)
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_94, [
      _hoisted_95,
      (_ctx.isXpOs)
        ? (_openBlock(), _createElementBlock("select", {
            key: 0,
            class: "hot-case-period-native-select",
            value: String(_ctx.quantGoldHotCasePeriod),
            onChange: _cache[48] || (_cache[48] = 
//@ts-ignore
(...args) => (_ctx.handleQuantGoldHotCasePeriodNativeChange && _ctx.handleQuantGoldHotCasePeriodNativeChange(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.QUANT_GOLD_STAT_PERIODS, (opt) => {
              return (_openBlock(), _createElementBlock("option", {
                key: opt.value,
                value: String(opt.value)
              }, _toDisplayString(opt.label), 9, _hoisted_97))
            }), 128))
          ], 40, _hoisted_96))
        : (_openBlock(), _createBlock(_component_a_select, {
            key: _ctx.hotCaseSelectKey,
            class: "hot-case-period-select",
            value: _ctx.quantGoldHotCasePeriod,
            style: {"width":"96px"},
            getPopupContainer: _ctx.getHotCaseSelectPopupContainer,
            dropdownClassName: _ctx.theme === 'dark' ? 'dark-dropdown' : 'light-dropdown',
            onChange: _ctx.handleQuantGoldHotCasePeriodChange,
            onDropdownVisibleChange: _ctx.handleHotCasePeriodDropdownVisibleChange
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.QUANT_GOLD_STAT_PERIODS, (opt) => {
                return (_openBlock(), _createBlock(_component_a_select_option, {
                  key: opt.value,
                  value: opt.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(opt.label), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value", "getPopupContainer", "dropdownClassName", "onChange", "onDropdownVisibleChange"]))
    ], 512), [
      [_vShow, _ctx.isQuantGold && _ctx.quantGoldMainTab === 'hotCase']
    ]),
    (_ctx.showSelectedStockInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
          _hoisted_99,
          _createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.selectedStockCount), 1),
          _createElementVNode("span", _hoisted_101, _toDisplayString(_ctx.selectedStockDescription), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}